export { default } from './RadioDetail';
